import { useQuery } from 'react-query';
import { EmailTemplateService } from '../../../../services/EmailTemplateService';
import { EmailTemplate } from '../../../../entities/EmailTemplate';

export const useResolveApplicationEmailTemplate = (
  emailTemplateId: number,
  applicationId: number,
  enabled: boolean,
) => {
  return useQuery<EmailTemplate>(
    ['email-template', emailTemplateId, 'application', applicationId],
    () => {
      return EmailTemplateService.replaceVariables(
        emailTemplateId,
        applicationId,
      );
    },
    {
      enabled: enabled,
    },
  );
};
